








































import Vue from "vue"
import { Component } from "vue-property-decorator"
import CreateInspirationViewModel from "@/models/inspirations/createInspirationViewModel"
import { BACKGROUND_IMAGE_RATIO } from "@/appSettings";

@Component
export default class PageCreateInspirationComponent extends Vue {
    languages: string[] = [];
    isLoading = false;
    vm: CreateInspirationViewModel = new CreateInspirationViewModel();
    backgroundImageRatio = BACKGROUND_IMAGE_RATIO;
    get title(): string {
        return this.id ? "Редактирование вдохновения" : "Добавление вдохновения";
    }
    get id(): number {
        const routeId = this.$route.params.id;
        return routeId ? Number(routeId) : 0;
    }
    async created() {
        this.languages = await this.$cacheProvider.getLanguagesAsync();
        this.vm.initLanguages(this.languages);
        if (this.id) {
            await this.fetchData();
        }
    }
    async fetchData() {
      const res = await this.$api.InspirationService.getInspirationAsync(this.id);
      this.vm.fromServerModel(res);
    }
    save() {
      const isValid = (this.$refs.validator as any).isValid();
      if (!isValid) {
        return;
      }
      this.isLoading = true;
      const req = this.vm.toServerModel();
      this.$api.InspirationService.updateAsync(req);
      this.isLoading = false;
      this.$notification.success('Вдохновение успешно обновлено');
      this.$router.back();
    }
}
